import useAxios from '../utils/useAxios'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const fetchAllTopics = createAsyncThunk('topic/getAllTopics', (_, { rejectWithValue }) => {
    const api = useAxios();
    return api
      .get('/api/admin/private/topic/')
      .then(response => response.data)
      .catch(error => rejectWithValue(error))
})

export const createTopic = createAsyncThunk('topic/createTopic', (value, { rejectWithValue }) => {
    const api = useAxios();
    return api
      .post('/api/admin/private/topic/', value)
      .then(response => response.data)
      .catch(error => rejectWithValue(error))
})

export const updateTopic = createAsyncThunk('topic/updateTopic', (data, { rejectWithValue }) => {
    const { id, value } = data;
    const api = useAxios();
    return api
      .patch(`/api/admin/private/topic/${id}/`, value)
      .then(response => response.data)
      .catch(error => rejectWithValue(error))
})

export const deleteTopic = createAsyncThunk('topic/deleteTopic', (id, { rejectWithValue }) => {
    const api = useAxios();
    return api
      .delete(`/api/admin/private/topic/${id}/`)
      .then(response => response.data)
      .catch(error => rejectWithValue(error))
})
